// some parts borrowed from airbnb/react-dates
// The MIT License (MIT)
// Copyright (c) 2016 Airbnb

import React from "react"
import styled from "styled-components"

import PropTypes from "prop-types"

import moment from "moment-timezone"
import getCalendarMonthWeeks from "./daysInMonth"

import DayButton from "./DayButton"

const StyledTd = styled.td`
  textAlign: 'center',
  fontSize: 20,
  border: '0px solid #fff',
  padding: 5
`

const MonthTitle = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.primary};
`

function CalendarMonth({
  month,
  style,
  clickDay,
  isDisabled,
  isOnSale,
  selectedDays,
}) {
  const getWeeks = () => {
    return getCalendarMonthWeeks(month)
  }

  const isSelected = (d) => {
    return (
      selectedDays && !!selectedDays.find((day) => moment(day).isSame(d, "day"))
    )
  }

  const weeks = getWeeks()
  const headerWeek = weeks[1]
  return (
    <table
      id={`month-${month.format("MMMYY")}`}
      style={{
        ...style,
        width: "100%",
        backgroundColor: "#fff",
        color: "#333",
      }}
    >
      <thead>
        <tr>
          <th colSpan={7} style={{ textAlign: "center" }}>
            <MonthTitle>{headerWeek[0].format("MMMM YYYY")}</MonthTitle>
          </th>
        </tr>
        <tr>
          {headerWeek.map((day) => (
            <th
              style={{ textAlign: "center", width: "14%" }}
              key={`calheader-${day.format()}`}
            >
              {day.format("dd")}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {weeks.map((week, i) => (
          <tr key={`trr-${i}`}>
            {week.map((day, j) => {
              if (!day) return <StyledTd key={`td-null-${i}${j}`} />
              return (
                <StyledTd key={`td-${j}${i}`}>
                  <DayButton
                    day={day}
                    onClick={clickDay}
                    selected={isSelected(day)}
                    isDisabled={isDisabled(day)}
                    isOnSale={isOnSale(day)}
                  />
                </StyledTd>
              )
            })}
          </tr>
        ))}
      </tbody>
    </table>
  )
}

CalendarMonth.propTypes = {
  month: PropTypes.object.isRequired,
  selectedDays: PropTypes.array.isRequired,
  isDisabled: PropTypes.func.isRequired,
  isOnSale: PropTypes.func.isRequired,
  style: PropTypes.object,
  clickDay: PropTypes.func,
}

export default CalendarMonth
